// https://gist.github.com/paulsturgess/ebfae1d1ac1779f18487d3dee80d1258
import _ from 'lodash';

const RELEVANT_COMPONENT_IDS = ['2mlfg15ml933', 'wm5mdd6191hq'];
const SEVERITY_ERROR = 'error';
const SEVERITY_WARN = 'warn';
const SEVERITY_INFO = 'info';

const STATUS_MAP = [
  {
    status: 'major_outage',
    severity: SEVERITY_ERROR,
    message: `We're experiencing an outage on one of our systems`,
    show: true,
  },
  {
    status: 'partial_outage',
    severity: SEVERITY_ERROR,
    message: `We're experiencing a partial outage of one of our systems`,
    show: true,
  },
  {
    status: 'degraded_performance',
    message: `We're experiencing degraded performance`,
    severity: SEVERITY_WARN,
    show: true,
  },
  {
    status: 'under_maintenance',
    message: `At this moment we're doing maintenance on our services`,
    severity: SEVERITY_INFO,
    show: true,
  },
  {
    status: 'operational',
    severity: SEVERITY_INFO,
    message: null,
    show: false,
  },
];

export interface StatusNotification {
  message?: string;
  severity?: string;
  show?: boolean;
}

class StatuspageIoApi {
  private readonly data: any;

  constructor(apiResponseData: {}) {
    this.data = apiResponseData;
  }

  getNotification(): {} {
    let response: {} = this.data;

    if (response) {
      // Parse
      if (
        this.getRelevantComponents().length !== RELEVANT_COMPONENT_IDS.length
      ) {
        return StatuspageIoApi.notification(
          'Status not found for some components',
          SEVERITY_WARN,
          true,
        );
      }

      let worstStatus = this.getWorstStatus();
      if (worstStatus && worstStatus.show) {
        return StatuspageIoApi.notification(
          this.getMessage(),
          worstStatus.severity,
          true,
        );
      } else {
        return {};
      }
    } else {
      return StatuspageIoApi.notification(
        'Status could not be determined',
        'info',
        true,
      );
    }
  }

  getWorstStatus(): any {
    let statuses = _.map(this.getRelevantComponents(), 'status');
    for (let mapItem of STATUS_MAP) {
      if (statuses.includes(mapItem.status)) {
        return {
          message: mapItem.message,
          severity: mapItem.severity,
          show: mapItem.show,
        };
      }
    }
  }

  getMessage(): string {
    if (this.getFirstRelevantIncidents()) {
      return this.getFirstRelevantIncidents().name;
    }
    return this.getWorstStatus().message;
  }

  getRelevantComponents() {
    return _.filter(this.data.components, function (component) {
      return RELEVANT_COMPONENT_IDS.includes(component.id);
    });
  }

  getFirstRelevantIncidents(): any {
    let relevantIncidents;
    relevantIncidents = _.find(this.data.incidents, function (incident) {
      let hasRelevantComponent = false;
      incident.components.forEach((component) => {
        if (RELEVANT_COMPONENT_IDS.includes(component.id)) {
          hasRelevantComponent = true;
        }
      });
      return hasRelevantComponent;
    });
    return relevantIncidents ? relevantIncidents : null;
  }

  static notification(
    message: string,
    severity: string,
    show: boolean,
  ): StatusNotification {
    return {
      message: `${message}.`,
      severity: severity,
      show: show,
    };
  }
}

export default StatuspageIoApi;
